import React from 'react';
import { formStyles as styles } from './styles';

export default function StepIndicator({ currentStep }) {
    return (
        <div style={styles.stepIndicatorContainer}>
            {/* Step 1 */}
            <div style={styles.stepItem} key="step1">
                <div style={styles.stepCircle(currentStep === 1, currentStep > 1)}>
                    {currentStep > 1 ? (
                        <svg key="check1" style={{ width: '30px', height: '30px', color: 'white' }} fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                    ) : (
                        <svg key="user1" style={styles.stepIcon(currentStep === 1)} fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                        </svg>
                    )}
                </div>
                <span style={styles.stepLabel(currentStep === 1)}><span>Thông tin cơ bản</span></span>
            </div>

            {/* Connector 1-2 */}
            <div style={styles.stepConnector(currentStep >= 2)} key="conn12"></div>

            {/* Step 2 */}
            <div style={styles.stepItem} key="step2">
                <div style={styles.stepCircle(currentStep === 2, currentStep > 2)}>
                    {currentStep > 2 ? (
                        <svg key="check2" style={{ width: '30px', height: '30px', color: 'white' }} fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                    ) : (
                        <svg key="loc2" style={styles.stepIcon(currentStep === 2)} fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                        </svg>
                    )}
                </div>
                <span style={styles.stepLabel(currentStep === 2)}><span>Hình thức & Địa chỉ</span></span>
            </div>

            {/* Connector 2-3 */}
            <div style={styles.stepConnector(currentStep >= 3)} key="conn23"></div>

            {/* Step 3 */}
            <div style={styles.stepItem} key="step3">
                <div style={styles.stepCircle(currentStep === 3, false)}>
                    <svg key="sum3" style={styles.stepIcon(currentStep === 3)} fill="currentColor" viewBox="0 0 20 20">
                        <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
                        <path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clipRule="evenodd" />
                    </svg>
                </div>
                <span style={styles.stepLabel(currentStep === 3)}><span>Chi tiết đơn hàng</span></span>
            </div>
        </div>
    );
}
